/*******************************************************************************
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  *  Copyright © 2021 Pearson Education, Inc.
 *  *  All Rights Reserved.
 *  *
 *  * NOTICE:  All information contained herein is, and remains
 *  * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *  * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *  * patent applications, and are protected by trade secret or copyright law.
 *  * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 ******************************************************************************/


import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';


export class EdwTooltip extends React.Component {
    constructor(props) {
        super(props);
        this.state = { open:false}
    }
    handleTooltipClose = () => {
         this.setState({ open: false })
    };

    handleTooltipOpen = () => {
        (this.state.open)? this.setState({ open: false }) : this.setState({ open: true })        
    };
 
    render(){
               
        return (           
            <ClickAwayListener onClickAway={this.handleTooltipClose}>               
                    <Tooltip 
                        PopperProps={{
                            disablePortal: true,
                        }}
                        onClose={this.handleTooltipClose}
                        open={this.state.open}
                        disableFocusListener
                        disableHoverListener
                        disableTouchListener
                        title={this.props.title} arrow>
                        <Button onClick={this.handleTooltipOpen}><i className="question-tooltip-icon question-tooltip-app"></i></Button>
                    </Tooltip>           
            </ClickAwayListener>
        );
    }  
}
 